import PropTypes from 'prop-types'
import { Icon } from './Icon'
import classes from './index.module.scss'

export const NumNotification = ({ children, num, isTranslateTopRight }) => {
  return (
    <div className={classes.container}>
      {children}
      {num > 0 ? (
        <Icon num={num} isTranslateTopRight={isTranslateTopRight} />
      ) : null}
    </div>
  )
}

NumNotification.propTypes = {
  children: PropTypes.node.isRequired,
  num: PropTypes.number.isRequired,
  isTranslateTopRight: PropTypes.bool,
}

NumNotification.defaultProps = {
  isTranslateTopRight: true,
}
